import { CountryDto, CountryQueryApi } from '@src/Api/generated-global-event';
import { makeAutoObservable } from 'mobx';
import { IStatusApi, defaultStatusApi } from '../DUMEvents/DUMEvents.type';

export interface ICountryStore {
  countries: CountryDto[];
  status: IStatusApi;
  fetchCountry: (_api: CountryQueryApi) => void;
}

export class CountryStore implements ICountryStore {
  countries: CountryDto[] = [];
  status = defaultStatusApi as IStatusApi;

  constructor() {
    makeAutoObservable(this);
  }
  async fetchCountry(_api: CountryQueryApi) {
    try {
      this.status.isLoading = true;
      const res = await _api.countryGet();
      if (res.status === 200) {
        this.countries = res.data.data ?? [];
        this.status = {
          isSuccess: true,
          isLoading: false,
          isError: false,
          message: ''
        };
      }
    } catch (err) {
      if (err instanceof Error) {
        const checkErr = `${err}`.includes('undefined')
          ? 'Error, Something went wrong. Please refresh or try again later'
          : err;

        this.status = {
          isSuccess: false,
          isLoading: false,
          isError: true,
          message: `${checkErr}`
        };
      }
    }
  }
}

export const CountryStoreDefault: ICountryStore = {
  countries: [],
  status: {
    isLoading: true,
    isError: false,
    isSuccess: false,
    message: ''
  },
  fetchCountry: () => {
    //
  }
};
